import FeatherIcon from "feather-icons-react";
import "./reportTabs.css";

/**
 * The report modal's tab selector. One segmented control — a recessed track with the
 * active tab lifted out of it in the sheet's navy — shared by the per-property report
 * and the All-Properties report so both read as the same screen. It sticks to the top
 * of the scrollable modal body, so a long report never strands you away from the tabs.
 *
 * `tabs`: [{ id, label, icon?, count? }]. `actions` renders to the right.
 */
const ReportTabs = ({ tabs, active, onChange, actions }) => (
  <div className="rpt-tabs">
    <div className="rpt-tabs__track" role="tablist">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={active === t.id}
          className={`rpt-tab ${active === t.id ? "is-active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          {t.icon ? <FeatherIcon icon={t.icon} size={14} /> : null}
          <span>{t.label}</span>
          {t.count !== undefined ? <span className="rpt-tab__count">{t.count}</span> : null}
        </button>
      ))}
    </div>
    {actions ? <div className="rpt-tabs__actions">{actions}</div> : null}
  </div>
);

export default ReportTabs;
